<template>
  <div>
    <div class="search-bar-margin-bottom-cla">
      <div class="header_tool_cla">
        <el-tabs v-model="activeName" @tab-click="handleClick">
          <el-tab-pane
            :label="$t('statistics.apiCallDetail')"
            name="apiDetails"
          ></el-tab-pane>
          <el-tab-pane
            :label="$t('statistics.appCallDetail')"
            name="appDetails"
          ></el-tab-pane>
        </el-tabs>
      </div>
    </div>
    <div class="black_panel_cla">
      <apiDetails v-if="activeName === 'apiDetails'"></apiDetails>
      <appDetails v-if="activeName === 'appDetails'"></appDetails>
    </div>
  </div>
</template>

<script>
import apiDetails from './callDetails/apiDetails'
import appDetails from './callDetails/appDetails'
export default {
  data() {
    return {
      activeName: 'apiDetails'
    }
  },
  components: {
    apiDetails,
    appDetails
  },
  mounted() {},
  methods: {
    handleClick() {}
  }
}
</script>

<style scoped lang="less">
.header_tool_cla {
  /deep/ .el-tabs__header {
    margin: 0 0 3px 0;
  }
}
.black_panel_cla {
  min-height: 500px;
}
/deep/.el-tabs__nav-wrap {
  &::after {
    display: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/modules/statistics/callDetails.vue